/**
 * Header.class
 *
 * Handling of page header.
 *
 * (c) notwenidges übel UG, Dimitri Preiß (preiss@notwenidges-uebel.de)
 */

export default class Header {
    config = {
        navToggler: 'hamburger-icon',
        mobileNav: 'nav',
        desktopWidth: 1200,
    };

    constructor(elem, config) {
        this.config = {...this.config, ...config};

        this.init();
    }

    /**
     * Set dom references and register events.
     */
    init() {
        this.navToggler = document.getElementById(this.config.navToggler);
        this.mobileNav = document.getElementById(this.config.mobileNav);
        this.body = document.querySelector('body');
        this.searchForm = document.querySelector('.searchform') || false;

        this.registerEvent();
    }

    /**
     * Register events.
     */
    registerEvent() {
        const me = this;

        /** Hamburger toggle handler */
        if (me.navToggler) {
            this.navToggler.addEventListener('click', (e) => {
                me.onNavToggleHandler(e);
            });
        }

        if (me.searchForm) {
            document.querySelectorAll('.searchform-toggle').forEach((elem) => {
                elem.addEventListener('click', () => {
                    me.searchForm.classList.toggle('is-active');
                    document.body.classList.remove('menu-is-active');
                    me.mobileNav.classList.remove('menu-is-active');
                    me.navToggler.classList.remove('menu-is-active');
                });
            });
        }
    }

    /**
     *
     *
     * @returns {boolean}
     */
    isDesktop() {
        return window.innerWidth > this.config.desktopWidth;
    }

    /**
     * Handle click on burger icon to toggle main nav.
     *
     * @param event
     */
    onNavToggleHandler(event) {
        const me = this;

        event.preventDefault();

        if (me.isDesktop()) {
            document.body.classList.remove('menu-is-active');
            me.mobileNav.classList.remove('menu-is-active');
            me.navToggler.classList.remove('menu-is-active');
        } else {
            document.body.classList.toggle('menu-is-active');
            me.mobileNav.classList.toggle('menu-is-active');
            me.navToggler.classList.toggle('menu-is-active');
            me.searchForm.classList.remove('is-active');
        }
    }
}
